module.exports = __webpack_public_path__ + "static/media/Тяжмаш.e6cf2f97.webp";